// notify.js 修改后版本
import { createApp } from 'vue';
import GlobalNotify from '@/components/GlobalNotify.vue';

export default {
  install(app) {
    // 1. 创建并插入容器
    const container = document.createElement('div');
    container.id = 'global-notify-container';
    document.body.appendChild(container);

    // 2. 正确挂载组件
    const notifyInstance = createApp(GlobalNotify).mount(container);

    // 3. 全局方法注册
    app.config.globalProperties.$notify = (options) => {
      notifyInstance.show(options);
    };
  }
}
